export class SurveyEntity {
  corpId: number;
  id: number;
  reference: string;
  name: string;
  startDate: string;
  endDate: string;
  courseId: number;
  courseTypeId: number;
  modalityId: number;
  siteId: number;
  turnId: number;
  showInCampus: boolean;
  showInMagnament: boolean;
}


